import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const YardIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M12.0172 0.108979C12.3219 -0.0363264 12.6781 -0.0363264 12.9828 0.108979L20.8578 3.8588C21.4203 4.12597 21.6547 4.79625 21.3875 5.35872C21.1391 5.8837 20.5344 6.12743 19.9953 5.93526V9.37571C19.9953 10.6507 19.0859 11.7147 17.8766 11.9537L19.5078 21.7501H23.375C23.9984 21.7501 24.5 22.2516 24.5 22.8751C24.5 23.4985 23.9984 24 23.375 24H1.625C1.00156 24 0.5 23.4985 0.5 22.8751C0.5 22.2516 1.00156 21.7501 1.625 21.7501H5.48281L7.11406 11.9537C5.90938 11.7193 4.99531 10.6553 4.99531 9.37571V5.93526C4.46094 6.12743 3.85625 5.8837 3.60312 5.35872C3.33594 4.79625 3.575 4.12597 4.1375 3.8588L12.0125 0.108979H12.0172ZM12.5 2.37293L7.25 4.87125V6.00088H17.75V4.87125L12.5 2.37293ZM7.25 8.25077V9.37571C7.25 9.58195 7.41875 9.7507 7.625 9.7507H17.375C17.5812 9.7507 17.75 9.58195 17.75 9.37571V8.25077H7.25ZM16.0062 21.7501L12.5 18.7831L8.99375 21.7501H16.0062ZM9.39219 12.0006L9.21875 13.0552L12.5 15.8348L15.7859 13.0552L15.6078 12.0006H9.39219ZM8.7875 15.6379L8.14062 19.5283L10.7609 17.3113L8.7875 15.6426V15.6379ZM14.2438 17.3066L16.8641 19.5237L16.2172 15.6332L14.2438 17.3019V17.3066Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default YardIcon
